//#region ../erd-editor-schema/dist/v2/schema/tableEntity.js
var OrderType = {
	ASC: "ASC",
	DESC: "DESC"
};
var OrderTypeList = Object.values(OrderType);
//#endregion
export { OrderType, OrderTypeList };
